import { render, staticRenderFns } from "./Reportados.vue?vue&type=template&id=769e9294"
import script from "./Reportados.vue?vue&type=script&lang=js"
export * from "./Reportados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports